import RenderRouter from '@/routes';
import { AppProvider } from '@shopify/polaris';
import de from '@shopify/polaris/locales/de.json';
import en from '@shopify/polaris/locales/en.json';
import es from '@shopify/polaris/locales/es.json';
import fr from '@shopify/polaris/locales/fr.json';
import it from '@shopify/polaris/locales/it.json';
import vi from '@shopify/polaris/locales/vi.json';
import hi from './translate/hindu.json';

import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './App.css';
import { config } from './config';
import { apiCaller } from '@/redux/query';

function App() {
  const { i18n } = useTranslation();
  const { data: dataSetting } = apiCaller.useGetGeneralDetailQuery();

  const shop = useMemo(() => {
    config.shop = dataSetting?.data?.shop || '';
    return dataSetting?.data?.shop;
  }, [dataSetting?.data?.shop]);

  const languageJson = useMemo(() => {
    switch (i18n.language) {
      case 'it':
        return it;
      case 'de':
        return de;
      case 'es':
        return es;
      case 'fr':
        return fr;
      case 'vi':
        return vi;
      case 'hi':
        return hi;
      default:
        return en;
    }
  }, [i18n.language]);

  useEffect(() => {
    if (config && config.role !== 'admin' && shop) {
      const timer = setTimeout(() => {
        var crisp = document.createElement('script');
        crisp.setAttribute('src', `${process.env.REACT_APP_API_END_POINT}file/crisp.js?shop=${shop}`);
        crisp.setAttribute('id', 'age-verification-wix-crisp');
        crisp.appendChild(document.createTextNode(``));
        document.body.appendChild(crisp);
      }, 2500);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [shop]);

  useEffect(() => {
    i18n
      .loadNamespaces(['common', 'dashboard', 'popup', 'setting', 'checkout', 'translation', 'term-condition'])
      .then(() => console.log('Language loaded'));
    // eslint-disable-next-line
  }, [i18n.language]);

  return (
    <AppProvider i18n={languageJson} i18nIsDynamicList>
      <RenderRouter />
    </AppProvider>
  );
}

export default App;
